<div *ngIf="this.clientEntity !== null">
  <p>
    Bij de klantinstellingen van {{ this.clientEntity.name }} maak je een koppeling met een Snelstart
    administratie of een externe administratie.<br/>
    Hieronder kun je er voor kiezen de gegevens uit de administratie te gebruiken bij de jaarrapportage.<br/>
    Maak je na het inlezen wijzigingen in de administratie, dan worden deze NIET automatisch opnieuw ingelezen in de
    jaarrapportage.
  </p>
<!--  TODO: voor Wouter-->
  <ng-container *ngIf="!loginStatus && hasExternalProvider">
    <snelstart-ui-alert>
      Je bent uitgelogd bij {{this.externalProviderId}}
      <button (click)="goToExternalProvider()">Login bij {{this.externalProviderId}}</button>
    </snelstart-ui-alert>
  </ng-container>
  <form [formGroup]="sstAdminIdFg">
    <div>
      <snelstart-ui-select-form-control formControlName="inlezen"
                                        id="inlezenAdmin"
                                        label="Administratie inlezen"
                                        [options]="optionsJaNee"
                                        class="me-1 custom-input-250"
                                        (change)="checkData()"
      >
      </snelstart-ui-select-form-control>
    </div>
    <ng-container
      *ngIf="sstAdminIdFg.get('inlezen')?.value === true">
      <div>
        <snelstart-ui-select-form-control formControlName="administrationId"
                                          label="Selecteer administratie"
                                          [options]="administrationList"
                                          class="me-1 custom-input-250"
                                          (change)="onSelect(sstAdminIdFg.get('administrationId')?.value)">
        </snelstart-ui-select-form-control>
      </div>

      <div>
        <snelstart-ui-button [config]="administratieInlezen" type="primary"
                             class="me-1 pt-1 custom-input-250">
          Administratie inlezen
        </snelstart-ui-button>
      </div>
    </ng-container>
  </form>
</div>
